export default "__VITE_ASSET__CoQ8_N6Q__"